import { stripNdcDashes } from "./ndcUtils";

export const TEMP_NDCS_QUERY_KEY = ["temp-ndcs"];

export type PendingTempDrugRef = {
  ndc: string;
  blockingNdc?: string;
};

export const itemMatchesPendingTempDrug = (
  itemNdc: string,
  temp: PendingTempDrugRef,
): boolean => {
  const itemKey = stripNdcDashes(itemNdc);
  if (!itemKey) {
    return false;
  }
  const blockingKey = stripNdcDashes(temp.blockingNdc ?? temp.ndc);
  return itemKey === blockingKey;
};

export const filterPendingTempDrugsForReturnItems = <T extends PendingTempDrugRef>(
  pendingTemps: T[],
  returnItems: Array<{ ndc: string }> | undefined,
): T[] => {
  if (!pendingTemps.length || !returnItems?.length) {
    return [];
  }
  return pendingTemps.filter((temp) =>
    returnItems.some((item) => itemMatchesPendingTempDrug(item.ndc, temp)),
  );
};
